import {Component, Input, OnInit} from '@angular/core';
import polygonIcon from '@iconify/icons-mdi/vector-polygon';
import pointIcon from '@iconify/icons-mdi/map-marker-radius-outline';
import folderIcon from '@iconify/icons-mdi/folder-outline';
import stopDurationIcon from '@iconify/icons-mdi/clock-time-eight-outline';
import distanceIcon from '@iconify/icons-mdi/map-marker-distance';
import engineWorkTimeIcon from '@iconify/icons-mdi/engine-outline';
import fuelTotalConsumptionIcon from '@iconify/icons-mdi/fuel';
import speedAvgIcon from '@iconify/icons-mdi/speedometer';
import fuelTemperatureIcon from '@iconify/icons-mdi/coolant-temperature';
import {TransportIntervention, TransportInterventionPoi, durationToStr, TransportInterventionPoiGroupReport} from 'shared';

@Component({
  selector: 'app-transport-interventions-timeline',
  templateUrl: './transport-interventions-timeline.component.html',
  styleUrls: ['./transport-interventions-timeline.component.scss']
})
export class TransportInterventionsTimelineComponent implements OnInit {
  folderIcon = folderIcon;
  polygonIcon = polygonIcon;
  pointIcon = pointIcon;

  stopDurationIcon = stopDurationIcon;
  distanceIcon = distanceIcon;
  engineWorkTimeIcon = engineWorkTimeIcon;
  fuelTotalConsumptionIcon = fuelTotalConsumptionIcon;
  speedAvgIcon = speedAvgIcon;
  fuelTemperatureIcon = fuelTemperatureIcon;

  durationToStr = durationToStr;
  @Input()
  intervention: TransportIntervention;

  @Input()
  poiList: TransportInterventionPoi[];

  @Input()
  poiListGroupReport: TransportInterventionPoiGroupReport[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
